(() => {
  function ensureAvailability(url) {
    const u = new URL(url, window.location.origin);
    if (!u.searchParams.has('filter.v.availability')) {
      u.searchParams.set('filter.v.availability', '1');
    }
    return u.toString();
  }

  // 1) al cargar página
  if (location.pathname.startsWith('/collections/')) {
    const fixed = ensureAvailability(location.href);
    if (fixed !== location.href) {
      history.replaceState({}, '', fixed);
    }
  }

  // 2) interceptar navegación de filtros (AJAX)
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="filter."]');
    if (!link) return;

    const fixed = ensureAvailability(link.href);
    link.href = fixed;
  });

  // 3) interceptar history push del tema
  const push = history.pushState;
  history.pushState = function(state, title, url) {
    if (typeof url === 'string' && url.includes('/collections/')) {
      url = ensureAvailability(url);
    }
    return push.call(this, state, title, url);
  };
})();